const Menu = [{
  title: 'Dashboard',
  // group: 'apps',
  icon: 'dashboard',
  name: 'AdminDashboard',
  roles: ['admin']
}, {
  title: 'Badge Contacts',
  icon: 'contacts',
  name: 'AdminBadgeContacts',
  roles: ['admin']
}, {
  title: 'Messages',
  name: 'AdminMessageGroup',
  icon: 'message',
  roles: ['admin'],
  children: [
    {
      title: 'Messages',
      name: 'AdminMessages',
      icon: 'message',
      roles: ['admin']
    },
    {
      title: 'Message Groups',
      name: 'MessageGroups',
      icon: 'group',
      roles: ['admin']
    }
  ]
},
{
  title: 'Clients',
  name: 'Clients',
  icon: 'group',
  roles: ['admin'],
  children: [
    {
      title: 'Families',
      name: 'ClientList',
      icon: 'group',
      roles: ['admin']
    },
    {
      title: 'Agencies',
      name: 'Agencies',
      icon: 'supervisor_account',
      roles: ['admin']
    },
    {
      title: 'Children',
      name: 'ChildManagement',
      icon: 'child_care',
      roles: ['admin']
    },
    {
      title: 'CAIRS Families',
      icon: 'group',
      name: 'FamilyManagement',
      roles: ['admin']
    }
  ]
},
{
  title: 'Tasks',
  // group: 'apps',
  name: 'Tasks',
  icon: 'work_outline',
  roles: ['admin']
}, 
// {
//   title: 'Timelines',
//   // group: 'apps',
//   name: 'AdminTimelines',
//   icon: 'timeline',
//   roles: ['admin']
// },
{
  title: 'Templates',
  name: 'TemplatesGroup',
  icon: 'image',
  roles: ['admin'],
  children: [
    /* {
      title: 'Profile Templates',
      name: 'Templates',
      icon: 'image',
      roles: ['admin']
    }, */
    {
      title: 'Email Templates',
      name: 'EmailTemplate',
      icon: 'email',
      roles: ['admin']
    },
    {
      title: 'Website Templates',
      name: 'WebsiteTemplate',
      icon: 'web',
      roles: ['admin']
    }
  ]
}, {
  title: 'Client Domains',
  name: 'ClientDomains',
  icon: 'web',
  roles: ['admin']
},
{
  title: 'Profile Layouts',
  name: 'ProfileDocumentsList',
  icon: 'snippet_folder',
  roles: ['admin']
},
{
  title: 'Video Projects',
  name: 'allProjects',
  icon: 'video_library',
  roles: ['admin']
}, {
  title: 'App Versions',
  name: 'appVersions',
  icon: 'store',
  roles: ['admin']
}, {
  title: 'Surveys & Reports',
  name: 'SurveysReports',
  icon: 'bar_chart',
  roles: ['admin'],
  children: [
    {
      title: 'Surveys',
      name: 'Surveys',
      icon: 'feedback',
      roles: ['admin']
    },
    {
      title: 'Reports',
      name: 'Reports',
      icon: 'bar_chart',
      roles: ['admin']
    },
    {
      title: 'Payment Transactions',
      name: 'PaymentTransactions',
      icon: 'paid',
      roles: ['admin']
    },
    {
      title: 'Invoices',
      name: 'Invoices',
      icon: 'account_balance_wallet',
      roles: ['admin']
    },
    {
      title: 'Invoice Reports',
      name: 'InvoiceReports',
      icon: 'bar_chart',
      roles: ['admin']
    }
  ]
},
{
  title: 'Help & FAQs',
  name: 'HelpFAQ',
  icon: 'help',
  roles: ['admin'],
  children: [
    {
      title: 'FAQ',
      name: 'AdminFAQ',
      icon: 'question_answer',
      roles: ['admin']
    },
    {
      title: 'Help Videos',
      icon: 'video_library',
      name: 'AdminHelpVideos',
      roles: ['admin']
    },
    {
      title: 'Help Files',
      icon: 'help',
      name: 'AdminFiles',
      roles: ['admin']
    }
  ]
},
{
  title: 'Data Management',
  name: 'DataManagement',
  icon: 'library_books',
  roles: ['admin'],
  children: [
    {
      title: 'Countries',
      name: 'Countries',
      icon: 'outlined_flag',
      roles: ['admin']
    },
    {
      title: 'States',
      name: 'States',
      icon: 'device_hub',
      roles: ['admin']
    },
    {
      title: 'File Categories',
      icon: 'image',
      name: 'FileCategories',
      roles: ['admin']
    },
    {
      title: 'Music Tracks',
      icon: 'library_music',
      name: 'Music',
      roles: ['admin']
    }
  ]
},
{
  title: 'Home',
  icon: 'home',
  name: 'Dashboard',
  roles: ['parent']
},
{
  title: 'Education',
  icon: 'school',
  name: 'Education',
  roles: ['parent']
},
{
  title: 'Home',
  icon: 'home',
  name: 'ChildDashboard',
  roles: ['child']
},
{
  title: 'Parent Info',
  // group: 'apps',
  icon: 'info',
  name: 'AboutUs',
  roles: ['parent']
},
{
  title: 'About',
  // group: 'apps',
  icon: 'info',
  name: 'ChildInfo',
  roles: ['child']
},
// {
//   title: 'Parent Preferences',
//   // group: 'apps',
//   icon: 'person',
//   name: 'ParentPreferences',
//   roles: ['child']
// },
{
  title: 'Child Preferences',
  // group: 'apps',
  icon: 'child_care',
  name: 'ChildPreferences',
  roles: ['parent']
},
{
  title: 'Profile Layout',
  icon: 'snippet_folder',
  name: 'ProfileDocuments',
  roles: ['parent']
},
{
  title: 'Dashboard',
  // group: 'apps',
  icon: 'dashboard',
  name: 'AgencyDashboard',
  roles: ['agency', 'caseworker']
},
// {
//   title: 'Clients',
//   name: 'Clients',
//   icon: 'group',
//   roles: ['agency', 'caseworker'],
//   children: [
//     {
//       title: 'Families',
//       icon: 'group',
//       name: 'FamilyManagement',
//       roles: ['agency', 'caseworker']
//     },
//     {
//       title: 'Children',
//       name: 'ChildManagement',
//       icon: 'child_care',
//       roles: ['agency', 'caseworker']
//     },
//   ]
// },
{
  title: 'Families',
  icon: 'group',
  name: 'FamilyManagement',
  roles: ['agency', 'caseworker']
},
{
  title: 'Badge Contacts',
  icon: 'contacts',
  name: 'AgencyBadgeContacts',
  roles: ['agency', 'caseworker']
},
{
  title: 'Profile Layouts',
  name: 'ProfileDocumentsAgencyList',
  icon: 'snippet_folder',
  roles: ['agency', 'caseworker']
},
{
  title: 'Views',
  // group: 'apps',
  icon: 'remove_red_eye',
  name: 'AgencyActivity',
  roles: ['agency', 'caseworker']
}, {
  title: 'Blogs',
  // group: 'apps',
  icon: 'web_asset',
  name: 'Blog',
  roles: ['parent', 'child']
}, {
  title: 'Letters',
  // group: 'apps',
  icon: 'email',
  name: 'Letters',
  roles: ['parent', 'child']
}, {
  title: 'Albums',
  // group: 'Case',
  name: 'Albums',
  icon: 'photo_library',
  roles: ['parent', 'child']
}, {
  title: 'Videos',
  // group: 'apps',
  icon: 'video_library',
  name: 'Videos',
  roles: ['parent', 'agency', 'child', 'caseworker']
}, {
  title: 'Messages',
  icon: 'message',
  name: 'Messages',
  roles: ['parent', 'agency', 'caseworker']
}, {
  title: 'My Agencies',
  // group: 'apps',
  icon: 'group',
  name: 'MyAgencies',
  roles: ['parent']
},
{
  title: 'Campaign',
  icon: 'ad_units',
  name: 'BMCampaign',
  roles: ['parent']
},
{
  title: 'Payment Transactions',
  name: 'PaymentTransactions',
  icon: 'paid',
  roles: ['agency', 'caseworker']
},
{
  title: 'Campaigns',
  icon: 'ad_units',
  name: 'BMCampaignsAgency',
  roles: ['agency', 'caseworker'],
  children: [
    {
      title: 'Individual Campaigns',
      icon: 'person',
      name: 'BMCampaignsIndividual',
      roles: ['agency', 'caseworker']
    },
    {
      title: 'Group Campaign',
      icon: 'people',
      name: 'BMCampaignsGroup',
      roles: ['agency', 'caseworker']
    },
    {
      title: 'Group Requests',
      icon: 'contact_mail',
      name: 'BMCampaignsGroupRequests',
      roles: ['agency', 'caseworker']
    }
  ]
},
{
  title: 'Campaigns',
  icon: 'ad_units',
  name: 'BMCampaigns',
  roles: ['admin'],
  children: [
    {
      title: 'Individual Campaigns',
      icon: 'person',
      name: 'BMCampaignList',
      roles: ['admin']
    },
    {
      title: 'Group Campaign',
      icon: 'people',
      name: 'BMCampaignsGroup',
      roles: ['admin']
    },
    {
      title: 'Group Requests',
      icon: 'contact_mail',
      name: 'BMCampaignsGroupRequests',
      roles: ['admin']
    },
    {
      title: 'Configuration',
      icon: 'settings',
      name: 'BMCampaignConfig',
      roles: ['admin']
    }
  ]
},
{
  title: 'Approval Requests',
  name: 'EditRequests',
  icon: 'contact_mail',
  roles: ['admin', 'agency', 'caseworker'],
  children: [
    /* {
      title: 'Blogs',
      name: 'BlogRequests',
      icon: 'web_asset',
      roles: ['admin']
    }, */
    {
      title: 'Display Name',
      name: 'DisplayNameChange',
      icon: 'edit',
      roles: ['admin']
    },
    {
      title: 'Enable Menu Back',
      name: 'EnableMenuRequests',
      icon: 'grading',
      roles: ['agency', 'caseworker']
    },
    {
      title: 'Family Content',
      name: 'FamilyContentRequests',
      icon: 'verified',
      roles: ['agency', 'caseworker']
    }
  ]
},
{
  title: 'Social Media',
  // group: 'apps',
  icon: 'share',
  name: 'SocialMedia',
  roles: ['parent']
},
{
  title: 'Membership',
  icon: 'card_membership',
  name: 'Membership',
  roles: ['parent']
},
{
  title: 'Profile Settings',
  icon: 'settings',
  name: 'ProfileSettings',
  roles: ['parent', 'child'],
  children: [
    {
      title: 'Username / Display Name',
      // group: 'apps',
      icon: 'account_box',
      name: 'ChangeUsername',
      roles: ['parent']
    },
    {
      title: 'Change Password',
      // group: 'apps',
      icon: 'lock',
      name: 'ChangePassword',
      roles: ['parent']
    },
    {
      title: 'Contact Information',
      // group: 'apps',
      name: 'ContactInformation',
      icon: 'phone',
      roles: ['parent', 'child']
    },
    {
      title: 'Add More Data',
      // group: 'apps',
      name: 'AddMoreData',
      icon: 'contact_mail',
      roles: ['parent']
    }
  ]
},
{
  title: 'Payment Transactions',
  name: 'ParentPaymentTransactions',
  icon: 'paid',
  roles: ['parent']
},
{
  title: 'Settings',
  icon: 'settings',
  name: 'SettingsGroup',
  roles: ['admin', 'agency', 'caseworker'],
  children: [
    {
      title: 'Profile Layout',
      icon: 'snippet_folder',
      name: 'ProfileLayoutSettings',
      roles: ['admin', 'agency', 'caseworker']
    },
    {
      title: 'Family Badge',
      icon: 'local_offer',
      name: 'FamilyBadgeManagement',
      roles: ['admin', 'agency', 'caseworker']
    },
    // {
    //   title: 'Child Badge',
    //   icon: 'child_care',
    //   name: 'ChildBadgeManagement',
    //   roles: ['admin', 'agency', 'caseworker']
    // },
    {
      title: 'Configuration',
      icon: 'settings',
      name: 'Configuration',
      roles: ['admin', 'agency', 'caseworker']
    },
    {
      title: 'Client Domains',
      name: 'ClientDomainsConfig',
      icon: 'web',
      roles: ['admin', 'agency', 'caseworker']
    },
    {
      title: 'Change Password',
      icon: 'lock',
      name: 'ChangePassword',
      roles: ['agency', 'caseworker']
    },
    {
      title: 'REST API',
      icon: 'move_up',
      name: 'APISettings',
      roles: ['admin', 'agency', 'caseworker']
    },
    {
      title: 'Memberships',
      icon: 'card_membership',
      name: 'Memberships',
      roles: ['admin', 'agency', 'caseworker']
    },
    {
      title: 'Accounts',
      icon: 'group',
      name: 'Accounts',
      roles: ['agency']
    },
    {
      title: 'Youtube',
      icon: 'subscriptions',
      name: 'Youtube',
      roles: ['admin', 'agency', 'caseworker']
    },
    {
      title: 'GoogleAds',
      icon: 'ads_click',
      name: 'GoogleAds',
      roles: ['admin']
    },
    {
      title: 'Task Details',
      icon: 'work_outline',
      name: 'TaskDetailsSettings',
      roles: ['admin']
    },
    {
      title: 'Signup Form',
      icon: 'fact_check',
      name: 'SignupForm',
      roles: ['admin', 'agency', 'caseworker']
    },
    {
      title: 'Family Menu',
      icon: 'list',
      name: 'FamilyMenu',
      roles: ['admin', 'agency', 'caseworker']
    },
    {
      title: 'Family Content',
      icon: 'verified',
      name: 'FamilyContent',
      roles: ['agency', 'caseworker']
    },
    {
      title: 'Blogs',
      icon: 'web_asset',
      name: 'BlogSettings',
      roles: ['admin', 'agency', 'caseworker']
    },
    {
      title: 'Blacklist',
      icon: 'block',
      name: 'Blacklist',
      roles: ['admin']
    }
  ]
},
{
  title: 'FAQ',
  name: 'FAQ',
  icon: 'question_answer',
  roles: ['agency', 'parent', 'caseworker']
},
// {
//   title: 'Reset Password',
//   // group: 'apps',
//   icon: 'lock',
//   name: 'ResetPassword',
//   roles: ['admin']
// },
{
  title: 'Logout',
  // group: 'apps',
  icon: 'exit_to_app',
  name: 'Logout',
  roles: ['*']
},
];
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;


// WEBPACK FOOTER //
// ./src/api/menu.js